const palette = [
    '#8e99f3',
    '#ffca28',
    '#5c6bc0',
    '#bbdefb',
];
export default palette;
